const checkColorText = function () {
    const $target = $(".text-fixed");
    const scrollTop = $(window).scrollTop();
    const $elem = $(".text-fixed-color");
    const $bannerContent = $(".banner-content");
    const endBannerContent = $bannerContent.offset().top + $bannerContent.height() - 100;
    let color = "#fff"
    const top = $(window).width() < 992 ? 150 : $(window).height() / 2
    $elem.each(function (index, el) {
        const offsetTop = $(this).offset().top;
        if (offsetTop - scrollTop < top) {
            color = $(this).data("fixed-color");
        }
    });
    $target.css("color", color);


    //rever header
    // if (color == "#000") {
    //     $(".rio-header").css("filter", "invert(1)");
    // }
    // else {
    //     $(".rio-header").css("filter", "invert(0)")
    // }

    //revert background sticky text
    if (color == "#000") {
        $(".text-fixed.background").removeClass("transparent").addClass("invert")
    }
    else if (endBannerContent - scrollTop < 0) {
        $(".text-fixed.background").removeClass("invert").addClass("transparent")
    }
    else {
        $(".text-fixed.background").removeClass("transparent").removeClass("invert")
    }

    let headerTransparent = false;
    $elem.each(function (index, el) {
        const offsetTop = $(this).offset().top;
        if (offsetTop - 800 - scrollTop < 0 && offsetTop - 800 - scrollTop > - 600) {
            headerTransparent = true
        }
    });
    if ($(window).width() > 992) {
        if (headerTransparent) {
            $(".rio-header").addClass("transparent")
        }
        else {
            $(".rio-header").removeClass("transparent")
        }
    }
    if (color == "#000") {
        $(".rio-header").addClass("invert")
    }
    else {
        $(".rio-header").removeClass("invert")
    }


}

const initLogoSlide = function () {
    $('.logo-slide').slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        fade: false,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 3000,
        rows: 3,
        slidesPerRow: 6,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    rows: 6,
                    slidesPerRow: 3,
                }
            }
        ]
    });
}

const initSlideBrand = function () {
    const $container = $(".slide-brand-container");
    $container.find(".slide-band-item").on("click", function () {
        const oldItem = $container.find(".active");
        const newItem = $(this);
        const color = $(this).data("color")
        // oldItem.find(".title").fadeOut(150, function(){
        //     $(this).fadeIn(150);
        // });
        // newItem.find(".title").fadeOut(150, function(){
        //     $(this).fadeIn(300);
        // });
        oldItem.removeClass("active").css("background-color", "transparent");
        newItem.addClass("active").css("background-color", color);
        $container.css("background-color", color);

    })
}

const homepage = () => {
    if ($(".homepage2").length) {
        $(window).on("scroll", function () {
            checkColorText();
        })
        initSlideBrand();
        initLogoSlide();
    }
}

module.exports = homepage
